import { Outlet, Link } from "react-router-dom";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { RequireAuth } from "@/lib/auth";
import AppPrefetch from "./AppPrefetch";

import logoSrc from "@/assets/logo.svg";
import PendingCheckout from "./PendingCheckout";
import CheckoutSuccess from "./CheckoutSuccess";
import VercelDomainSync from "./VercelDomainSync";
import RequireSubscription from "./RequireSubscription";
import TrialExpiringBanner from "./TrialExpiringBanner";
import PaymentIssueBanner from "./PaymentIssueBanner";
import OnboardingTour from "./OnboardingTour";
import { SubscribeModalProvider } from "./SubscribeModalProvider";
import { Suspense } from "react";
import { GenericPageSkeleton } from "./PageSkeletons";

export default function AppLayout() {
  return (
    <RequireAuth>
      <SubscribeModalProvider>
        <AppPrefetch />
        <RequireSubscription />
        <PendingCheckout />
        <CheckoutSuccess />
        <VercelDomainSync />
        <OnboardingTour />
        <SidebarProvider>
          <div className="min-h-screen flex w-full">
            <AppSidebar />
              <main className="flex-1 min-w-0">
                <header className="sticky top-0 z-10 bg-background h-14 flex items-center border-b border-border px-4 relative">
                <SidebarTrigger />
                <Link to="/app/dashboard" className="absolute left-1/2 -translate-x-1/2 sm:hidden">
                  <img src={logoSrc} alt="Magnetiq" className="h-5" width={98} height={20} />
                </Link>
              </header>
              <PaymentIssueBanner />
              <TrialExpiringBanner />
              <div className="p-3 sm:p-6 overflow-x-clip min-w-0 w-full">
                <Suspense fallback={<GenericPageSkeleton />}>
                  <Outlet />
                </Suspense>
              </div>
            </main>
          </div>
        </SidebarProvider>
      </SubscribeModalProvider>
    </RequireAuth>
  );
}
